import React, { useEffect, useRef, useState } from "react";
import mapboxgl from "mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import "mapbox-gl/dist/mapbox-gl.css";
import { Box } from "@chakra-ui/react";
mapboxgl.accessToken =
  "pk.eyJ1IjoiamFuc2Fqb3NlIiwiYSI6ImNrbmlmenZ4NjJ1aWoycGxjdG1qbGhwY2wifQ.waif_7e7ELIHRq8HH7OuVw";

interface MapComponentProps {
  geocodes: number[];
  address: string;
}
const AddressMapComponent: React.FC<MapComponentProps> = ({ geocodes, address }) => {
  const map = React.useRef(null as any);
  const searchMarker = useRef(null as any);
  const searchMarkerPopup = useRef(null as any);
  const [coordinates, setCoordinates] = useState(geocodes);
  const [locationAddress, setLocationAddress] = useState(address);

  useEffect(() => {
    map.current = new mapboxgl.Map({
      container: "map-container",
      style: "mapbox://styles/mapbox/streets-v11",
      // projection: "globe" as any,
      center: [coordinates[0] || 78.515278, coordinates[1] || 17.377778], // Starting position [lng, lat]
      zoom: coordinates[0] && coordinates[1] ? 17 : 3, // Starting zoom
    });

    // Clean up on unmount
    return () => map.current.remove();
  }, [coordinates]);

  useEffect(() => {
    if (searchMarker.current) {
      searchMarker.current.remove();
    }
    // Create a marker with an initial position
    searchMarker.current = new mapboxgl.Marker({ color: "#000000" })
      .setLngLat([coordinates[0], coordinates[1]])
      .addTo(map.current);

    // Create a popup with the description
    searchMarkerPopup.current = new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
      offset: 25,
    }).setText(locationAddress);
    searchMarker.current.setPopup(searchMarkerPopup.current);

    // Show popup on marker hover
    searchMarker.current.getElement().addEventListener("mouseenter", () => {
      if (!searchMarker.current.getPopup().isOpen()) {
        searchMarker.current.togglePopup();
      }
    });

    // Hide popup when mouse leaves marker
    searchMarker.current.getElement().addEventListener("mouseleave", () => {
      if (searchMarker.current.getPopup().isOpen()) {
        searchMarker.current.togglePopup();
      }
    });
  }, [coordinates, locationAddress]);

  useEffect(() => {
    map.current.flyTo({
      center: coordinates,
    });
    setCoordinates(geocodes);
    setLocationAddress(address);
  }, [geocodes, address]);

  return (
    <Box
      id="map-container"
      position="relative"
      style={{ width: "100%", height: "40vw" }}
    />
  );
};

export default AddressMapComponent;
